import { translateLanguage } from 'components';
import { OnlineBookingContent } from 'models';
import * as Yup from 'yup';
import { phoneValidation } from './phone-no-schema';

export const onlineBookingSearchSchema = Yup.object().shape({
  locationId: Yup.string().required(
    `${translateLanguage(`OnlineBooking.${OnlineBookingContent.LOCATIONREQ}`)}`,
  ),
  procedureId: Yup.string().required(
    `${translateLanguage(
      `OnlineBooking.${OnlineBookingContent.TREATMENTREQ}`,
    )}`,
  ),
  staffId: Yup.string().required(
    `${translateLanguage(`OnlineBooking.${OnlineBookingContent.STAFFREQ}`)}`,
  ),
  appointmentDate: Yup.date().required(
    `${translateLanguage(`OnlineBooking.${OnlineBookingContent.DATEREQ}`)}`,
  ),
});

export const onlineBookingAppointmentSchema = Yup.object().shape({
  firstName: Yup.string().required(
    `${translateLanguage(
      `OnlineBooking.${OnlineBookingContent.FIRSTNAMEREQ}`,
    )}`,
  ),
  lastName: Yup.string().required(
    `${translateLanguage(`OnlineBooking.${OnlineBookingContent.LASTNAMEREQ}`)}`,
  ),
  dob: Yup.string()
    .nullable()
    .required(
      `${translateLanguage(`OnlineBooking.${OnlineBookingContent.DOBREQ}`)}`,
    ),
  // gender: Yup.string().required(
  //   `${translateLanguage(`OnlineBooking.${OnlineBookingContent.GENDERREQ}`)}`,
  // ),
  phoneNumber: phoneValidation('req'),
  email: Yup.string().required(
    `${translateLanguage(`OnlineBooking.${OnlineBookingContent.EMAILREQ}`)}`,
  ),
});
